<div *ngIf="userLogin$ | async as user; else notLoggedIn" class="main-div">
  <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutAlign="center">
    <mat-card>
      <mat-card-header>
        <mat-card-title> Olá, {{ user?.nomeUsuario }} </mat-card-title>
        <mat-card-subtitle>Utilize o menu lateral para acessar as funcionalidades</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <hr />
        <table>
          <tr *ngIf="user?.campus">
            <td>Unidade:</td>
            <td>
              {{ user?.campus }}<span *ngIf="user?.sigla"> - {{ user?.sigla }}</span>
            </td>
          </tr>
          <tr *ngIf="user?.nomeLotacaoOficial">
            <td>Lotação:</td>
            <td>{{ user?.nomeLotacaoOficial }}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #notLoggedIn>
  <div class="main-div">
    <mat-card class="card">
      <mat-card-header>
        <mat-card-title>Bem vindo(a)</mat-card-title>
        <mat-card-subtitle class="card-subtitle">Efetue login para acessar o sistema</mat-card-subtitle>
      </mat-card-header>
      <mat-card-actions class="card-button">
        <button mat-flat-button color="primary" (click)="login()">Autenticação Central UNICAMP</button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>
